export default "__VITE_PUBLIC_ASSET__3eb9284e__"